import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">{contactData.description}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto">
          {contactData.infoItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 text-center hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-3 rounded-full bg-accent-50 flex items-center justify-center">
                <i className={`${item.icon} text-accent-500 text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.label}</h3>
              <p className="text-xs md:text-sm text-foreground-500 break-all">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}